import { render } from "./Uploader.vue?vue&type=template&id=3d2e0926&scoped=true"
import script from "./Uploader.vue?vue&type=script&lang=js"
export * from "./Uploader.vue?vue&type=script&lang=js"

import "./Uploader.vue?vue&type=style&index=0&id=3d2e0926&scoped=true&lang=less"

import exportComponent from "/var/www/eventgallery/build/tmpBuildDir/components/com_eventgallery/media/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d2e0926"],['__file',"backend/vue/uploader/Uploader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d2e0926"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d2e0926', __exports__)) {
    api.reload('3d2e0926', __exports__)
  }
  
  module.hot.accept("./Uploader.vue?vue&type=template&id=3d2e0926&scoped=true", () => {
    api.rerender('3d2e0926', render)
  })

}


export default __exports__